//PAGES
export const EVENT_DASHBOARD_PAGE = 'dashboard';
export const EVENT_CREDIT_RATINGS_SEARCH_PAGE = 'credit_ratings_search';
export const EVENT_EXECUTIVE_SUMMARY_PAGE = 'executive summary';
export const EVENT_GHG_SUMMARY_PAGE = 'GHG';
export const EVENT_SDG_SUMMARY_PAGE = 'SDG';
export const EVENT_PROJECT_COMPARISON_PAGE = 'GHG';
export const EVENT_RETIREMENT_INSIGHTS_PAGE = 'retirement_insights';
export const EVENT_RETIREMENT_INSIGHTS_COMPANY_DRILL_DOWN_PAGE =
  'retirement_insights_company_drill_down';
export const EVENT_BLOG_PAGE = 'blog';
export const EVENT_ESR_RATING_PAGE = 'esr_rating';
export const EVENT_WHERE_TO_BUY_PAGE = 'where_to_buy';
export const EVENT_INSIGHTS_HUB_PAGE = 'research-hub';
export const EVENT_PROGRAM_SCREENING_PAGE = 'program_screening';
export const EVENT_SELLER_OFFERS_PAGE = 'seller_offers';
export const EVENT_FREEMIUM_DASHBOARD_PAGE = 'dashboard';
export const EVENT_ACCOUNT_CREATION_AND_ONBOARDING_PAGE = 'account_creation_and_onboarding';
export const EVENT_UPGRADE_PAGE = 'upgrade';
export const EVENT_DEVELOPER_PORTAL_PAGE = 'developer_portal';
export const EVENT_CONTACT_PAGE = 'contact';
export const EVENT_COMPASS_PAGE = 'compass';
export const EVENT_SUPPLYLINK_PAGE = 'supplylink';
export const EVENT_EXPERT_ADVISORY_PAGE = 'expert_advisory';
export const EVENT_PROJECT_SCREENER_PAGE = 'project_screener';

//DASHBOARD PAGE EVENTS
export const EVNTAPP_tab_recently_added = 'EVNTAPP_tab_recently_added';
export const EVNTAPP_tab_most_retired = 'EVNTAPP_tab_most_retired';
export const EVNTAPP_tab_most_issued = 'EVNTAPP_tab_most_issued';
export const EVNTAPP_tab_following = 'EVNTAPP_tab_following';
export const EVNTAPP_blog_show_more = 'EVNTAPP_blog_show_more';
export const EVNTAPP_SDG_btn_click = 'EVNTAPP_SDG_btn_click';
export const EVNTAPP_GHG_btn_click = 'EVNTAPP_GHG_btn_click';
export const EVNTAPP_search_enter = 'EVNTAPP_search_enter';
export const EVNTAPP_search_click = 'EVNTAPP_search_click';

//CREDIT RATINGS SEARCH PAGE EVENTS
export const EVNT_ratings_filter_panel_opened = 'EVNT_ratings_filter_panel_opened';
export const EVNT_ratings_filters_applied = 'EVNT_ratings_filters_applied';
export const EVNT_ratings_view_toggled = 'EVNT_ratings_view_toggled';
export const EVNT_ratings_table_searched = 'EVNT_ratings_table_searched';
export const EVNT_ratings_table_error = 'EVNT_ratings_table_error';
export const EVNT_ratings_table_no_results = 'EVNT_ratings_table_no_results';
export const PGV_search_credit_ratings = 'PGV_search_credit_ratings';

//EXECUTIVE SUMMARY PAGE EVENTS
export const EVNTAPP_attribute_detail_clicked = 'EVNTAPP_attribute_detail_clicked';
export const PGV_exec_summary = 'PGV_exec_summary';
export const EVNT_exec_GHG_rating_tile_clicked = 'EVNT_exec_GHG_rating_tile_clicked';
export const EVNT_exec_SDG_rating_tile_clicked = 'EVNT_exec_SDG_rating_tile_clicked';
export const EVNT_exec_ESR_screening_tile_clicked = 'EVNT_exec_ESR_screening_tile_clicked';
export const EVNT_exec_follow_project_clicked = 'EVNT_exec_follow_project_clicked';
export const EVNT_exec_want_to_sell_credits_submitted = 'EVNT_exec_want_to_sell_credits_submitted';
export const EVNT_exec_want_to_buy_credits_submitted = 'EVNT_exec_want_to_buy_credits_submitted';
// Request-rating / Request-ESR-screening entry points ON the Exec Summary page.
// These REPLACE the generic EVNT_request_ghg_rating / EVNT_request_esr_screening
// (+ _submitted) events here; the generic events still fire from the ESR rating
// page. The _submitted variants fire only after a successful POST.
export const EVNT_exec_request_GHG_rating_clicked = 'EVNT_exec_request_GHG_rating_clicked';
export const EVNT_exec_request_ESR_screening_clicked = 'EVNT_exec_request_ESR_screening_clicked';
export const EVNT_exec_request_GHG_rating_submitted = 'EVNT_exec_request_GHG_rating_submitted';
export const EVNT_exec_request_ESR_screening_submitted =
  'EVNT_exec_request_ESR_screening_submitted';
export const EVNT_exec_market_labels_expand_clicked = 'EVNT_exec_market_labels_expand_clicked';

//PRICING AND SUPPLY PAGE EVENTS
export const EVENT_PRICING_AND_SUPPLY_PAGE = 'pricing_and_supply';
export const PGV_pricing_and_supply = 'PGV_pricing_and_supply';
export const EVNT_pricing_supply_connect_to_seller_clicked =
  'EVNT_pricing_supply_connect_to_seller_clicked';

//GHG SUMMARY PAGE EVENTS
export const EVNTAPP_ghg_section_clicked = 'EVNTAPP_ghg_section_clicked';
export const EVNTAPP_tab_overview = 'EVNTAPP_tab_overview';
export const EVNTAPP_tab_additionality = 'EVNTAPP_tab_additionality';
export const EVNTAPP_tab_overcrediting = 'EVNTAPP_tab_overcrediting';
export const EVNTAPP_tab_permanence = 'EVNTAPP_tab_permanence';
export const EVNTAPP_view_deep_dive_click = 'EVNTAPP_view_deep_dive_click';
export const PGVAPP_deep_dive_content_viewed = 'PGVAPP_deep_dive_content_viewed';
export const PGVAPP_upgrade_modal_viewed = 'PGVAPP_upgrade_modal_viewed';
export const PGVAPP_submit_upgrade_modal_viewed = 'PGVAPP_submit_upgrade_modal_viewed';
export const EVNTAPP_submit_upgrade_modal_clicked = 'EVNTAPP_submit_upgrade_modal_clicked';
export const EVNTAPP_upgrade_request_submitted = 'EVNTAPP_upgrade_request_submitted';
export const PGV_ghg_summary = 'PGV_ghg_summary';

//SDG SUMMARY PAGE EVENTS
export const EVNT_sdg_go_to_esr_screening_clicked = 'EVNT_sdg_go_to_esr_screening_clicked';
export const PGVAPP_SDG_rating = 'PGVAPP_SDG_rating';

//PROJECT COMPARISON / PROJECT ANALYTICS PAGE EVENTS
export const EVNTAPP_activity_year_click = 'EVNTAPP_activity_year_click';
export const EVNTAPP_vintage_click = 'EVNTAPP_vintage_click';
export const EVNTAPP_retiree_analytics_change_pageSize =
  'EVNTAPP_retiree_analytics_change_pageSize';
export const EVNTAPP_retiree_analytics_sort_retiree = 'EVNTAPP_retiree_analytics_sort_retiree';
export const EVNTAPP_retiree_analytics_sort_2024 = 'EVNTAPP_retiree_analytics_sort_2024';
export const EVNTAPP_retiree_analytics_sort_2023 = 'EVNTAPP_retiree_analytics_sort_2023';
export const EVNTAPP_retiree_analytics_sort_2022 = 'EVNTAPP_retiree_analytics_sort_2022';
export const EVNTAPP_retiree_analytics_sort_2021 = 'EVNTAPP_retiree_analytics_sort_2021';
export const EVNTAPP_retiree_analytics_sort_2020 = 'EVNTAPP_retiree_analytics_sort_2020';
export const EVNTAPP_retiree_analytics_sort_total = 'EVNTAPP_retiree_analytics_sort_total';

//RETIREE INSIGHTS PAGE EVENTS
export const EVNTAPP_retiree_insights_change_pageSize = 'EVNTAPP_retiree_insights_change_pageSize';
export const EVNTAPP_retiree_insights_sort_retiree = 'EVNTAPP_retiree_insights_sort_retiree';
export const EVNTAPP_retiree_insights_sort_2024 = 'EVNTAPP_retiree_insights_sort_2024';
export const EVNTAPP_retiree_insights_sort_2023 = 'EVNTAPP_retiree_insights_sort_2023';
export const EVNTAPP_retiree_insights_sort_2022 = 'EVNTAPP_retiree_insights_sort_2022';
export const EVNTAPP_retiree_insights_sort_2021 = 'EVNTAPP_retiree_insights_sort_2021';
export const EVNTAPP_retiree_insights_sort_2020 = 'EVNTAPP_retiree_insights_sort_2020';
export const EVNTAPP_retiree_insights_sort_total = 'EVNTAPP_retiree_insights_sort_total';

//BLOG PAGE EVENTS
export const EVNTAPP_blog_detail_click = 'EVNTAPP_blog_detail_click';

//ESR EVENTS
export const PGV_esr_summary = 'PGV_esr_summary';
export const EVNT_esr_section_clicked = 'EVNT_esr_section_clicked';
export const EVNT_request_esr_screening = 'EVNT_request_esr_screening';
export const EVNT_request_esr_screening_submitted = 'EVNT_request_esr_screening_submitted';
export const EVNT_request_ghg_rating = 'EVNT_request_ghg_rating';
export const EVNT_request_ghg_rating_submitted = 'EVNT_request_ghg_rating_submitted';
export const EVNT_esr_comparison_view_toggled = 'EVNT_esr_comparison_view_toggled';
export const EVNT_esr_see_methodology_details_clicked = 'EVNT_esr_see_methodology_details_clicked';

//WHERE TO BUY PAGE EVENTS
export const EVNTAPP_view_more_on_seller_website = 'EVNTAPP_view_more_on_seller_website';
export const EVNTAPP_register_interest = 'EVNTAPP_register_interest';
export const EVNTAPP_project_name = 'EVNTAPP_project_name';
export const EVNTAPP_portfolio_bundle = 'EVNTAPP_portfolio_bundle';
export const EVNTAPP_portfolio_bundle_dropdown = 'EVNTAPP_portfolio_bundle_dropdown';
export const EVNTAPP_bundle_project_name = 'EVNTAPP_bundle_project_name';

//TOP MENU EVENTS
export const EVNTAPP_search_menu_click = 'EVNTAPP_search_menu_click';
export const EVNTAPP_contact_menu_click = 'EVNTAPP_contact_menu_click';
export const EVNTAPP_following_menu_click = 'EVNTAPP_following_menu_click';
export const EVNTAPP_myprofile_menu_click = 'EVNTAPP_myprofile_menu_click';
export const EVNTAPP_signout_menu_click = 'EVNTAPP_signout_menu_click';
export const EVNTAPP_retiree_insights_menu_click = 'EVNTAPP_retiree_insights_menu_click';
export const EVNTAPP_programs_menu_click = 'EVNTAPP_programs_menu_click';
export const EVNTAPP_research_hub_menu_click = 'EVNTAPP_research_hub_menu_click';

//LEFT NAVIGATION EVENTS
export const EVNTAPP_executive_summary_menu_click = 'EVNTAPP_executive_summary_menu_click';
export const EVNTAPP_ghg_rating_menu_click = 'EVNTAPP_ghg_rating_menu_click';
export const EVNTAPP_sdg_rating_menu_click = 'EVNTAPP_sdg_rating_menu_click';
export const EVNTAPP_esr_rating_menu_click = 'EVNTAPP_esr_rating_menu_click';
export const EVNTAPP_related_content_menu_click = 'EVNTAPP_related_content_menu_click';
export const EVNTAPP_pricing_and_supply_menu_click = 'EVNTAPP_pricing_and_supply_menu_click';

//RETIREMENT INSIGHTS V2 EVENTS
export const PGV_retirement_insights = 'PGV_retirement_insights';
export const EVNT_retirement_insights_filter_panel_opened =
  'EVNT_retirement_insights_filter_panel_opened';
export const EVNT_retirement_table_filters_applied = 'EVNT_retirement_table_filters_applied';
export const EVNT_retirement_table_searched = 'EVNT_retirement_table_searched';
export const PGV_retirement_company_drilldown = 'PGV_retirement_company_drilldown';
export const EVNT_retirement_company_chart_breakdown_selected =
  'EVNT_retirement_company_chart_breakdown_selected';
export const EVNT_retirement_company_breakdown_toggled =
  'EVNT_retirement_company_breakdown_toggled';
export const EVNT_retirement_company_widget_filters_applied =
  'EVNT_retirement_company_widget_filters_applied';

//Insights Hub Events
export const PGV_research_hub_main = 'PGV_research_hub_main';
export const PGV_research_hub_content_detail = 'PGV_research_hub_content_detail';
export const PGV_research_hub_category_detail = 'PGV_research_hub_category_detail';
export const EVNT_research_hub_searched = 'EVNT_research_hub_searched';
export const EVNT_research_hub_resource_downloaded = 'EVNT_research_hub_resource_downloaded';
//PROGRAM SCREENING
export const PGV_program_screening = 'PGV_program_screening';
export const EVNT_program_approach_clicked = 'EVNT_program_approach_clicked';
export const EVNT_request_program_screening = 'EVNT_request_program_screening';
export const EVNT_request_program_screening_submitted = 'EVNT_request_program_screening_submitted';

//SELLER INVENTORY PAGE EVENTS
export const PGV_seller_offers = 'PGV_seller_offers';
export const EVNT_offers_connect_to_seller_clicked = 'EVNT_offers_connect_to_seller_clicked';

//FREEMIUM DASHBOARD PAGE EVENTS
export const EVNT_dashboard_video_clicked = 'EVNT_dashboard_video_clicked';
export const EVNT_dashboard_video_stopped = 'EVNT_dashboard_video_stopped';
export const EVNT_dashboard_video_played = 'EVNT_dashboard_video_played';
export const PGV_account_get_started = 'PGV_account_get_started';
export const PGV_account_step_one = 'PGV_account_step_one';
export const PGV_account_step_two = 'PGV_account_step_two';
export const PGV_account_step_three = 'PGV_account_step_three';
export const PGV_account_step_four = 'PGV_account_step_four';
export const EVNT_account_created = 'EVNT_account_created';
export const PGV_onboarding_step_one = 'PGV_onboarding_step_one';
export const PGV_onboarding_step_two = 'PGV_onboarding_step_two';
export const PGV_upgrade_page = 'PGV_upgrade_page';
export const EVNT_exec_example_deep_dive_learn_more_clicked =
  'EVNT_exec_example_deep_dive_learn_more_clicked';
export const EVNT_nav_upgrade_clicked = 'EVNT_nav_upgrade_clicked';
export const EVNT_retirement_upgrade_button_clicked = 'EVNT_retirement_upgrade_button_clicked';

//DEVELOPER PORTAL EVENTS
export const PGV_developer_portal = 'PGV_developer_portal';
export const PGV_developer_rating_request_form = 'PGV_developer_rating_request_form';
export const EVNT_developer_rating_request_submitted = 'EVNT_developer_rating_request_submitted';
export const PGV_developer_rating_notification_form = 'PGV_developer_rating_notification_form';
export const EVNT_developer_rating_notification_submitted =
  'EVNT_developer_rating_notification_submitted';
export const PGV_developer_contact_us_form = 'PGV_developer_contact_us_form';
export const EVNT_developer_contact_us_submitted = 'EVNT_developer_contact_us_submitted';

//UPGRADE PAGE EVENTS
export const EVNT_upgrade_top_contact_us_clicked = 'EVNT_upgrade_top_contact_us_clicked';
export const EVNT_upgrade_bottom_contact_us_clicked = 'EVNT_upgrade_bottom_contact_us_clicked';
export const EVNT_upgrade_explore_compass_clicked = 'EVNT_upgrade_explore_compass_clicked';

//CONTACT PAGE EVENTS
export const EVNT_contact_form_submitted = 'EVNT_contact_form_submitted';
export const PGV_contact_form = 'PGV_contact_form';
export const PGV_compass = 'PGV_compass';
export const PGV_compass_overview = 'PGV_compass_overview';
export const PGV_compass_supply_demand = 'PGV_compass_supply_demand';
export const PGV_compass_top_ghg_risks = 'PGV_compass_top_ghg_risks';
export const PGV_compass_top_ghg_risks_deep_dive = 'PGV_compass_top_ghg_risks_deep_dive';
export const EVNT_compass_risks_project_example_clicked =
  'EVNT_compass_risks_project_example_clicked';
export const PGV_compass_methodologies_overview = 'PGV_compass_methodologies_overview';
export const EVNT_compass_methodologies_detail_tab_clicked =
  'EVNT_compass_methodologies_detail_tab_clicked';
export const EVNT_compass_methodologies_expand_summary_clicked =
  'EVNT_compass_methodologies_expand_summary_clicked';
export const EVNT_compass_methodologies_collapse_summary_clicked =
  'EVNT_compass_methodologies_collapse_summary_clicked';

//SUPPLYLINK PAGE EVENTS
export const PGV_supplylink = 'PGV_supplylink';
export const EVNT_supplylink_request_for_info_clicked = 'EVNT_supplylink_request_for_info_clicked';
export const EVNT_supplylink_request_for_info_submitted =
  'EVNT_supplylink_request_for_info_submitted';
export const EVNT_supplylink_book_call_clicked = 'EVNT_supplylink_book_call_clicked';
export const EVNT_supplylink_call_scheduled = 'EVNT_supplylink_call_scheduled';
export const EVNT_supplylink_connect_to_seller_clicked =
  'EVNT_supplylink_connect_to_seller_clicked';
export const EVNT_supplylink_inquire_with_seller_submitted =
  'EVNT_supplylink_inquire_with_seller_submitted';
export const EVNT_supplylink_open_in_email_client_clicked =
  'EVNT_supplylink_open_in_email_client_clicked';
export const EVNT_supplylink_request_rating_submitted = 'EVNT_supplylink_request_rating_submitted';
export const EVNT_supplylink_request_rating_clicked = 'EVNT_supplylink_request_rating_clicked';
export const EVNT_supplylink_filters_applied = 'EVNT_supplylink_filters_applied';
export const EVNT_supplylink_copy_email_text_clicked = 'EVNT_supplylink_copy_email_text_clicked';
export const EVNT_supplylink_searched = 'EVNT_supplylink_searched';
export const EVNT_supplylink_table_no_results = 'EVNT_supplylink_table_no_results';

//ADVISORY PAGE EVENTS
export const PGV_services = 'PGV_services';
export const PGV_services_detail = 'PGV_services_detail';
export const EVNT_services_get_quote_clicked = 'EVNT_services_get_quote_clicked';
export const EVNT_services_get_quote_submitted = 'EVNT_services_get_quote_submitted';
export const EVNT_services_book_call_clicked = ' EVNT_services_book_call_clicked';
export const EVNT_services_call_scheduled = 'EVNT_services_call_scheduled';
export const EVNT_services_sample_report_clicked = 'EVNT_services_sample_report_clicked';

//PROJECT SCREENER PAGE EVENTS
export const PGV_screener_list = 'PGV_screener_list';
export const PGV_screener_new = 'PGV_screener_new';
export const PGV_screener_report = 'PGV_screener_report';
export const PGV_screener_faq = 'PGV_screener_faq';
export const EVNT_screener_beta_interest_clicked = 'EVNT_screener_beta_interest_clicked';
export const EVNT_screener_browse_files_clicked = 'EVNT_screener_browse_files_clicked';
export const EVNT_screener_screening_initiated = 'EVNT_screener_screening_initiated';
export const EVNT_screener_screening_completed = 'EVNT_screener_screening_completed';
export const EVNT_screener_screening_error = 'EVNT_screener_screening_error';
export const EVNT_screener_download_report_clicked = 'EVNT_screener_download_report_clicked';
// Dashboard "Get answers from our experts" research widget.
export const EVENT_RESEARCH_WIDGET = 'dashboard_research_widget';
export const EVNT_research_question_submitted = 'EVNT_research_question_submitted';
export const EVNT_research_call_opened = 'EVNT_research_call_opened';
export const EVNT_research_call_submitted = 'EVNT_research_call_submitted';

export const EVENT_TOU_MODAL = 'tou_modal';
export const PGV_TOU_modal_shown = 'PGV_TOU_modal_shown';
export const EVNT_TOU_modal_accepted = 'EVNT_TOU_modal_accepted';

// ─────────────────────────────────────────────────────────────────────────
// My Plan & VAS analytics (analytics_sheet.pdf) — Tutorials, Dashboard,
// My Plan, Deep-dive Requests, My Requests. Usage: track(EVENT_NAME, SOURCE,
// { ...props }); PGV_* fire on load, EVNT_* on the action.
// ─────────────────────────────────────────────────────────────────────────

// Sources (track() arg2 / current_page). Dashboard reuses EVENT_DASHBOARD_PAGE.
export const EVENT_TUTORIAL = 'tutorial';
export const EVENT_MY_PLAN_PAGE = 'my_plan';
export const EVENT_DEEP_DIVE_REQUESTS_PAGE = 'deep_dive_requests';
export const EVENT_MY_REQUESTS_PAGE = 'my_requests';

// Tutorials (in-app onboarding tour)
export const PGV_tutorial_screen_shown = 'PGV_tutorial_screen_shown';
export const EVNT_tutorial_screen_main_cta_clicked = 'EVNT_tutorial_screen_main_cta_clicked';
export const EVNT_tutorial_screen_secondary_cta_clicked =
  'EVNT_tutorial_screen_secondary_cta_clicked';
export const EVNT_tutorial_screen_closed = 'EVNT_tutorial_screen_closed';

// Dashboard
export const PGV_dashboard = 'PGV_dashboard';
export const EVNT_dashboard_question_submitted = 'EVNT_dashboard_question_submitted';
export const EVNT_dashboard_request_call_clicked = 'EVNT_dashboard_request_call_clicked';
export const EVNT_dashboard_request_call_submitted = 'EVNT_dashboard_request_call_submitted';
export const EVNT_dashboard_fastpass_clicked = 'EVNT_dashboard_fastpass_clicked';
export const EVNT_dashboard_fastpass_submitted = 'EVNT_dashboard_fastpass_submitted';
export const EVNT_dashboard_deep_dive_clicked = 'EVNT_dashboard_deep_dive_clicked';
export const EVNT_dashboard_deep_dive_submitted = 'EVNT_dashboard_deep_dive_submitted';
export const EVNT_dashboard_new_vas_request_clicked = 'EVNT_dashboard_new_vas_request_clicked';
export const EVNT_dashboard_vas_request_submitted = 'EVNT_dashboard_vas_request_submitted';

// My Plan
export const PGV_my_plan = 'PGV_my_plan';
export const EVNT_my_plan_fastpass_clicked = 'EVNT_my_plan_fastpass_clicked';
export const EVNT_my_plan_fastpass_submitted = 'EVNT_my_plan_fastpass_submitted';
export const EVNT_my_plan_deep_dive_clicked = 'EVNT_my_plan_deep_dive_clicked';
export const EVNT_my_plan_deep_dive_submitted = 'EVNT_my_plan_deep_dive_submitted';
export const EVNT_my_plan_subscription_help_clicked = 'EVNT_my_plan_subscription_help_clicked';

// Deep-dive Requests
export const PGV_deep_dive_requests = 'PGV_deep_dive_requests';
export const EVNT_deep_dive_request_clicked = 'EVNT_deep_dive_request_clicked';
export const EVNT_deep_dive_request_submitted = 'EVNT_deep_dive_request_submitted';

// My Requests
export const PGV_my_requests = 'PGV_my_requests';
export const EVNT_my_requests_new_request_clicked = 'EVNT_my_requests_new_request_clicked';
export const EVNT_my_requests_quote_submitted = 'EVNT_my_requests_quote_submitted';
export const EVNT_my_requests_report_downloaded = 'EVNT_my_requests_report_downloaded';

// RATINGS QUEUE (Upcoming ratings tab + request-a-rating + quote/paywall + onboarding/FAQ)
export const EVENT_UPCOMING_RATINGS_PAGE = 'upcoming_ratings';
export const PGV_upcoming_ratings = 'PGV_upcoming_ratings';
export const PGV_upcoming_rating_faq = 'PGV_upcoming_rating_faq';
// M1 queue tab
export const EVNT_queue_viewed = 'EVNT_queue_viewed';
export const EVNT_queue_vote_cast = 'EVNT_queue_vote_cast';
export const EVNT_queue_vote_removed = 'EVNT_queue_vote_removed';
export const EVNT_queue_fastpass_clicked = 'EVNT_queue_fastpass_clicked';
// M2 request-a-rating + fastpass
export const EVNT_queue_fastpass_confirmed = 'EVNT_queue_fastpass_confirmed';
export const EVNT_queue_fastpass_applied = 'EVNT_queue_fastpass_applied';
export const EVNT_queue_fastpass_fee_requested = 'EVNT_queue_fastpass_fee_requested';
// M3 quote + paywall
export const EVNT_upcoming_ratings_quote_submitted = 'EVNT_upcoming_ratings_quote_submitted';
export const EVNT_upcoming_ratings_buy_fastpasses_submitted =
  'EVNT_upcoming_ratings_buy_fastpasses_submitted';
export const EVNT_upcoming_ratings_upgrade_clicked = 'EVNT_upcoming_ratings_upgrade_clicked';
// "Add a project to the queue" form submit (customer submits an un-indexed project).
export const EVNT_upcoming_ratings_add_to_queue_submitted =
  'EVNT_upcoming_ratings_add_to_queue_submitted';
